import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Select } from 'primeng/select';

import { AuthService, Rol } from '../../../core/services/auth.service';
import { FactorService } from '../../../core/services/factor.service';
import { AppIconComponent } from '../../components/app-icon/app-icon.component';

interface OpcionFactor {
  label: string;
  value: number | null;
}

@Component({
  selector: 'app-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, RouterLink, Select, AppIconComponent],
  templateUrl: './app-header.component.html',
})
export class AppHeaderComponent {
  protected readonly auth = inject(AuthService);
  private readonly factorService = inject(FactorService);

  protected readonly roles: Rol[] = ['Tesoreria', 'TIC', 'Contabilidad'];
  protected readonly rolLabel: Record<Rol, string> = {
    Tesoreria: 'Tesorería',
    TIC: 'TIC',
    Contabilidad: 'Contabilidad',
  };

  /** Filtro de factor — Reactive Forms. Arranca en LIQUITECH (factor por defecto). */
  protected readonly factorCtrl = new FormControl<number | null>(null);

  protected readonly opcionesFactor = computed<OpcionFactor[]>(() => [
    { label: 'Todos los factores', value: null },
    ...this.factorService.factores().map((f) => ({ label: f.nombre, value: f.id })),
  ]);

  constructor() {
    this.factorCtrl.valueChanges
      .pipe(takeUntilDestroyed())
      .subscribe((v) => this.factorService.seleccionar(v ?? null));

    // LIQUITECH como factor por defecto (el MVP opera sobre este factor).
    const porDefecto = this.factorService.factores().find((f) => /liquitech/i.test(f.nombre))?.id;
    if (porDefecto != null) this.factorCtrl.setValue(porDefecto);
  }

  protected setRol(rol: Rol): void {
    this.auth.setRolVista(rol);
  }
}
